//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Loader,
  OrganisationSelectionModal,
  Screen,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  AllApplicationsApi,
  GetUserDetailsApi,
  setGeneralDetails,
  SignupLoginApi,
  useGeneralDetails,
  useSignupLoginApiDetails,
  ValidateTokenApi,
} from "Slices";
//Utils
import {
  ChangeHistory,
  EventManager,
  EventNames,
  getURLParameter,
  validateEmailDashboard,
} from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import NotificationIcon from "assets/icons/notification.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
import FreeForeverIcon from "assets/Dashboard/icons/free.svg";
import FrictionlessLoginIcon from "assets/Dashboard/icons/improve.svg";
import PreventAccountTakeoversIcon from "assets/Dashboard/icons/prevent.svg";
import GmailIcon from "assets/icons/gmail.svg";
import YahooIcon from "assets/icons/yahoo.png";
import OutlookIcon from "assets/icons/outlook.png";
import BharatPeLogo from "assets/company logos/bharatpe.svg";
import BillBookLogo from "assets/company logos/billbook.svg";
import DstreetLogo from "assets/company logos/dstreet-finance-logo-white.svg";
import ElectricpeLogo from "assets/company logos/electricpe.svg";
import RiveLogo from "assets/company logos/rive-temp-logo.svg";
import SecureNowLogo from "assets/company logos/secure now.png";
import StraightLineLogo from "assets/company logos/Straight-Line-Logo-Blue.svg";
import ZtockLogo from "assets/company logos/ztocks-logo.png";
import PostPeLogo from "assets/company logos/postpe.svg";
import ParkLogo from "assets/company logos/park.svg";
import CapriLogo from "assets/company logos/capri.svg";
import CootzLogo from "assets/company logos/cootz.svg";
import SayFLogo from "assets/company logos/sayf.svg";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [apiHit, setApiHit] = useState(false);
  const [
    organisationSelectionModalVisibility,
    setOrganisationSelectionModalVisibility,
  ] = useState(false);
  const clientId =
    "900526788390-p28pj1ite99tmsf9u024umhfc9gnc9ih.apps.googleusercontent.com";

  //Slices
  const generalDetails = useGeneralDetails();

  useEffect(() => {
    if (getURLParameter("showSuccessToast") === "true") {
      toast.success("Email sent successfully!");
    }
    if (generalDetails?.initiateEmail?.to) {
      setEmail(generalDetails?.initiateEmail?.to);
    } else {
      ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
    }
    if (getURLParameter("token")) {
      fetchSessionToken({
        token: getURLParameter("token"),
      });
    } else {
      EventManager.send(
        EventNames.EVENTS_NAME.DASHBOARD.SIGNUP_LOGIN.PAGE_VIEW
      );
      const initClient = () => {
        gapi.client.init({
          clientId: clientId,
          scope: "",
        });
      };
      gapi.load("client:auth2", initClient);
    }
  }, []);

  useEffect(() => {
    if (getURLParameter("id_token")) {
      console.log({
        token: getURLParameter("id_token"),
      });
      window.localStorage.setItem("token", getURLParameter("id_token"));
      // history.push("/order-qr");
    }
  }, [getURLParameter("id_token")]);

  const fetchSessionToken = (data: any) => {
    dispatch(
      ValidateTokenApi({
        authToken: data.token,
        callback: saveToken,
      })
    );
  };

  const saveToken = (data: any) => {
    window.history.pushState(
      {},
      document.title,
      ROUTE_PATH.DASHBOARD.SIGNUP_LOGIN
    );
    if (data.token) {
      localStorage.setItem("token", data.token);
      dispatch(
        GetUserDetailsApi({
          callback: checkOrganisations,
        })
      );
    }
  };

  const checkOrganisations = (userDetails) => {
    if (userDetails?.organizations?.length > 1) {
      setOrganisationSelectionModalVisibility(true);
    } else {
      localStorage.setItem(
        "organisationID",
        userDetails?.organizations?.[0]?.id
      );
      localStorage.setItem("organisationIndex", `0`);
      setGeneralDetails({
        selectedOrganisation: userDetails?.organizations?.[0],
      });
      setTimeout(() => {
        getApplicationList();
      }, 0);
    }
  };

  const getApplicationList = () => {
    dispatch(
      AllApplicationsApi({
        organizationId: localStorage.getItem("organisationID"),
        callback: setRouting,
      })
    );
  };

  const setRouting = (applicationList) => {
    applicationList?.length > 0
      ? ChangeHistory("push", ROUTE_PATH.DASHBOARD.ACTIVITY)
      : ChangeHistory("push", ROUTE_PATH.DASHBOARD.HOME);
  };

  const loginApi = (data: any) => {
    dispatch(
      SignupLoginApi({
        ...data,
        utm_source: getURLParameter("utm_source"),
        utm_medium: getURLParameter("utm_medium"),
        utm_campaign: getURLParameter("utm_campaign"),
      })
    );
  };

  const responseGoogle = (response) => {
    console.log({ response });
    // const userObject = jwt_decode(response.credential);
    // console.log({ userObject });
    loginApi({
      googleToken: response.tokenId,
      email: response.profileObj.email,
      type: "GOOGLE",
      callback: fetchSessionToken,
    });
  };

  const emailResponse = (response: any) => {
    if ("token" in response) {
      EventManager.send(
        EventNames.EVENTS_NAME.DASHBOARD.SIGNUP_LOGIN.LOGIN_CLICK
      );
      setApiHit(true);
    }
  };

  const signup = () => {
    if (validateEmailDashboard(email)) {
      loginApi({
        email,
        type: "EMAIL",
        callback: emailResponse,
      });
    } else {
      toast.error("Please enter your work email.");
    }
  };

  const openEmailApp = (link: string) => {
    ChangeHistory("blank", link);
  };

  const Advantages = (
    <div className="advantages">
      <FlexBox className="animated fadeInLeft" alignCenter>
        <Image src={FrictionlessLoginIcon} className="w-8 mr-r-20" />
        <div>
          <p className="font-heavy fs-20 mr-v-5">2-Tap Login Experience</p>
          <p className="fs-14">
            Resulting in{" "}
            <span className="clr-theme font-heavy">lower drop-offs</span> &{" "}
            <span className="clr-theme font-heavy">Higher NPS</span>{" "}
          </p>
        </div>
      </FlexBox>

      <FlexBox className="animated fadeInLeft delay-02s mr-v-40" alignCenter>
        <Image src={PreventAccountTakeoversIcon} className="w-8 mr-r-20" />
        <div>
          <p className="font-heavy fs-20 mr-v-5">Prevent Account Takeovers</p>
          <p className="fs-14">
            Enhance{" "}
            <span className="clr-theme font-heavy">trust and safety</span> with
            WhatsApp’s End to End Encryption.
          </p>
        </div>
      </FlexBox>
      <FlexBox className="animated fadeInLeft delay-01s" alignCenter>
        <Image src={FreeForeverIcon} className="w-8 mr-r-20" />
        <div>
          <p className="font-heavy fs-20 mr-v-5">Free Forever</p>
          <p className="fs-14">
            Bring your SMS <span className="clr-theme font-heavy">OTP</span>{" "}
            costs to <span className="clr-theme font-heavy">zero</span>
          </p>
        </div>
      </FlexBox>
    </div>
  );

  //Return UI
  return (
    <Screen hasHeader hasFooter className="signup-login-screen">
      <FlexBox justifyBetween alignCenter className="pd-h-60 h-70 main-content">
        <FlexBox flexColumn justifyEvenly className="w-55 lef-content">
          <p className="font-heavy fs-36">Get started with OTPless</p>
          {Advantages}
        </FlexBox>
        <div className="w-40 flip-card">
          <p className="font-heavy fs-28 text-center mobile-view">
            Get started with OTPless
          </p>
          <div className={cx(apiHit && "clicked", "flip-card-inner")}>
            <Card className="pd-40 flip-card-front">
              <FlexBox justifyCenter flexColumn className="h-100">
                <p className="fs-28 font-heavy">Sign up or log in</p>
                <div
                  className="mr-t-40 google-button"
                  onClick={() => {
                    EventManager.send(
                      EventNames.EVENTS_NAME.DASHBOARD.SIGNUP_LOGIN
                        .GOOGLE_LOGIN_CLICK
                    );
                  }}
                >
                  <GoogleLogin
                    clientId={clientId}
                    buttonText="Login with Google"
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                    cookiePolicy={"single_host_origin"}
                    // uxMode="redirect"
                    // redirectUri="http://localhost:3000/dashboard/signup-login"
                  />
                </div>
                <div className="separator mr-v-40" />
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={"Enter Email"}
                  className="fs-18"
                  hasLabel
                />
                <Button
                  text={"Login"}
                  className="fs-16 mr-t-40 mr-b-20"
                  onClick={() => {
                    signup();
                  }}
                />
              </FlexBox>
            </Card>
            <Card className="pd-40 flip-card-back">
              <FlexBox justifyCenter flexColumn className="h-100">
                <p className="fs-28 font-heavy">Check your email</p>
                <p className="fs-14 mr-t-10 font-light">
                  An email was sent to {email}
                </p>
                <FlexBox
                  justifyCenter
                  alignCenter
                  onClick={() => {
                    openEmailApp("https://mail.google.com/mail");
                  }}
                  className="mr-t-40 border-bottom pd-b-20 curs-point"
                >
                  <Image src={GmailIcon} className="w-8 mr-r-10" />
                  <p className="fs-16">Open in Gmail</p>
                </FlexBox>
                <FlexBox
                  justifyCenter
                  alignCenter
                  onClick={() => {
                    openEmailApp("https://in.mail.yahoo.com");
                  }}
                  className="border-bottom pd-v-20 curs-point"
                >
                  <Image src={YahooIcon} className="w-8 mr-r-10" />
                  <p className="fs-16">Open in Yahoo</p>
                </FlexBox>
                <FlexBox
                  justifyCenter
                  alignCenter
                  onClick={() => {
                    openEmailApp("https://outlook.live.com/mail/0/");
                  }}
                  className="curs-point pd-v-20"
                >
                  <Image src={OutlookIcon} className="w-8 mr-r-10" />
                  <p className="fs-16">Open in Outlook</p>
                </FlexBox>
                <Button
                  text={"Try again"}
                  className="fs-16 mr-t-40 mr-b-20"
                  onClick={() => {
                    setApiHit(false);
                  }}
                />
              </FlexBox>
            </Card>
          </div>
          <div className="mobile-view mr-t-40">{Advantages}</div>
        </div>
      </FlexBox>
      <div className="marquee">
        <div className="track">
          <Image src={BharatPeLogo} className="mr-h-30" />
          <Image src={BillBookLogo} className="mr-h-30 bill-book-logo" />
          <Image src={DstreetLogo} className="mr-h-30" />
          <Image src={ElectricpeLogo} className="mr-h-30" />
          <Image src={RiveLogo} className="mr-h-30" />
          <Image src={SecureNowLogo} className="mr-h-30" />
          <Image src={StraightLineLogo} className="mr-h-30" />
          <Image src={ZtockLogo} className="mr-h-30" />
          <Image src={PostPeLogo} className="mr-h-30" />
          <Image src={ParkLogo} className="mr-h-30" />
          <Image src={CapriLogo} className="mr-h-30" />
          <Image src={CootzLogo} className="mr-h-30" />
          <Image src={SayFLogo} className="mr-h-30 sayf-logo" />
          <Image src={BharatPeLogo} className="mr-h-30" />
          <Image src={BillBookLogo} className="mr-h-30" />
          <Image src={DstreetLogo} className="mr-h-30" />
          <Image src={ElectricpeLogo} className="mr-h-30" />
          <Image src={RiveLogo} className="mr-h-30" />
          <Image src={SecureNowLogo} className="mr-h-30" />
          <Image src={StraightLineLogo} className="mr-h-30" />
          <Image src={ZtockLogo} className="mr-h-30" />
          <Image src={PostPeLogo} className="mr-h-30" />
          <Image src={ParkLogo} className="mr-h-30" />
          <Image src={CapriLogo} className="mr-h-30" />
          <Image src={CootzLogo} className="mr-h-30" />
          <Image src={SayFLogo} className="mr-h-30 sayf-logo" />
        </div>
      </div>
      <OrganisationSelectionModal
        visible={organisationSelectionModalVisibility}
        onClose={() => {
          setOrganisationSelectionModalVisibility(false);
          setTimeout(() => {
            getApplicationList();
          }, 0);
        }}
      />
    </Screen>
  );
};

export default Landing;
